import React from 'react';
import PropTypes from 'prop-types';
import DSFilterBar from '@elliemae/ds-filterbar';

var addOptionalHeaderComponents = function addOptionalHeaderComponents(_ref) {
  var grid = _ref.grid;

  var _grid$getInstance = grid.getInstance(),
      _grid$getInstance$pro = _grid$getInstance.props,
      showFilterBar = _grid$getInstance$pro.showFilterBar,
      renderFilterToolbar = _grid$getInstance$pro.renderFilterToolbar,
      filterBarOptions = _grid$getInstance$pro.filterBarOptions,
      filters = _grid$getInstance.state.filters,
      _grid$getInstance$act = _grid$getInstance.actions,
      removeFilter = _grid$getInstance$act.removeFilter,
      removeAllFilters = _grid$getInstance$act.removeAllFilters;

  var _ref2 = filterBarOptions || {},
      maxWidth = _ref2.maxWidth,
      minWidth = _ref2.minWidth;

  return /*#__PURE__*/React.createElement(React.Fragment, null, filters && !!filters.length && showFilterBar && /*#__PURE__*/React.createElement(DSFilterBar, {
    filters: filters,
    maxWidth: maxWidth,
    minWidth: minWidth,
    onRemoveAllFilters: removeAllFilters,
    onRemoveFilter: removeFilter,
    renderToolbar: renderFilterToolbar
  }));
};

addOptionalHeaderComponents.propTypes = {
  grid: PropTypes.any
};

export default addOptionalHeaderComponents;
//# sourceMappingURL=addOptionalHeaderComponents.js.map
